import { withTheme, SvyCallout as Callout } from '@innovorder/savory';

export const SvyCallout = withTheme(Callout);
